import router from './route/router'
import store from './store';
import storage from 'store';
import { LoadingBar } from 'iview';
import { USER_INFO, ACCESS_TOKEN, SHIFT_INFO, SHIFT_LIST, TENANT, ROLE_LIST, IS_PLATFORM } from './utils/env'
import { setDocumentTitle } from "./utils/domUtil"
import { Message } from 'element-ui'
import { getImTokenApi } from "./api/common"
router.beforeEach((to, from, next) => {
  LoadingBar.start();
  if (!store.state.access_token && !storage.get(ACCESS_TOKEN)) {
    if (to.name === 'login') {
      next();
    } else {
      next({ path: "/login", replace: true });
    }
  } else if (!store.state.access_token) {
    const user = storage.get(USER_INFO);
    let is_platform = storage.get(IS_PLATFORM);
    if (is_platform === null || is_platform === undefined) {
      let url;
      if (process.env.VUE_APP_HOSPITAL_CODE && (process.env.VUE_APP_HOSPITAL_CODE !== " ".trim()) && (process.env.VUE_APP_HOSPITAL_CODE !== ("CARING_1_HOSPITAL_CODE".split("_1").join("")))) {
        url = process.env.VUE_APP_HOSPITAL_CODE;
      }
      const t = process.env.NODE_ENV === 'development' ? 'prm.chinacaring.com'.split('.')[0] : (url || location.host.split('.')[0])
      if (t !== 'prm') {
        is_platform = false
      } else {
        is_platform = true
      }
    }
    store.commit("setAccessToken", storage.get(ACCESS_TOKEN));
    store.commit("setUser", user);
    store.commit('setPlatform', is_platform);
    const tenant = storage.get(TENANT + store.state.user.user.id);
    if (tenant && tenant.tenant) {
      store.commit("setTenant", tenant);
      setDocumentTitle(tenant.remake);
      const role = storage.get(ROLE_LIST + store.state.user.user.id + store.state.tenant.tenant);
      if (!(role && role.length)) {
        store.dispatch('Logout').finally(() => {
          next({
            path: "/login", replace: true
          })
        })
      }
      store.commit("setRoleList", role);
      const cur = storage.get(SHIFT_INFO + store.state.user.user.id + store.state.tenant.tenant);
      const list = storage.get(SHIFT_LIST + store.state.user.user.id + store.state.tenant.tenant);
      store.commit("setShift", cur);
      store.commit("setShiftList", list);
      const institution = list.find(l => l.institution_id === cur.institution_id) || {};
      const dept =
        institution.shift_dept_responses &&
        institution.shift_dept_responses.length
          ? (institution.shift_dept_responses.find(d => d.dept_id === cur.dept_id) || {})
          : {};
      const disease =
        dept.shift_disease_responses &&
        dept.shift_disease_responses.length
          ? (dept.shift_disease_responses.find(d => d.disease_id === cur.disease_id) || {})
          : {};
      const team =
        disease.shift_team_responses &&
        disease.shift_team_responses.length
          ? (disease.shift_team_responses.find(t => t.team_id === cur.team_id) || {})
          : {};
      const userMenus = team.menu_list || disease.menu_list || dept.menu_list || institution.menu_list || []
      store.commit("setUserMenus", userMenus);
      if (userMenus.length) {
        if (userMenus[0] && userMenus[0].child_menus.length) {
          store.commit("setAllSelectedKeys", {
            type: "add",
            name: userMenus[0].child_menus[0].router,
            title: userMenus[0].child_menus[0].name,
            key: userMenus[0].child_menus[0].router,
            extra: {},
          });
        } else {
          store.commit("setAllSelectedKeys", {
            type: "add",
            name: userMenus[0].router,
            title: userMenus[0].name,
            key: userMenus[0].router,
            extra: {},
          });
        }
      }
      getImTokenApi().then(res => {
        if (res.code === 0) {
          store.commit('setIm', res.data);
        } else {
          Message.error('获取im接口服务异常!!!');
        }
      })
      if (to.name === 'tenants') {
        next({ path: "/base", replace: true });
      } else {
        next()
      }
    } else {
      if (to.name === 'tenants') {
        next()
      } else {
        next({
          path: "/tenants",
          replace: true
        })
      }
    }
  } else {
    if (store.state.tenant && store.state.tenant.tenant) {
      getImTokenApi().then(res => {
        if (res.code === 0) {
          store.commit('setIm', res.data);
        } else {
          Message.error('获取im接口服务异常!!!');
        }
      })
      if ((to.name === 'tenants' || to.name === 'login') && from.name === 'base') {
        next(false);
        LoadingBar.finish();
        window.scrollTo(0, 0);
      } else {
        next();
      }
    } else {
      if (to.name === 'tenants') {
        next()
      } else {
        next({
          path: "/tenants",
          replace: true
        })
      }
    }
  }
});

router.afterEach((to, from, next) => {
  LoadingBar.finish();
  window.scrollTo(0, 0);
})
